/**
 * A deterministic permission error (Postgres 42501 / insufficient_privilege)
 * is never fixed by retrying — react-query's default backoff (1s/2s/4s)
 * just triples the noise. Everything else keeps react-query's default
 * (retry up to 3 times).
 *
 * See docs/plans/2026-09-04-staff-planning-read-scope.md — plain staff
 * hitting a legitimately-scoped 42501 no longer spams prod logs.
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (isPermissionError(error)) return false;
  return failureCount < 3;
}

function isPermissionError(error: unknown): boolean {
  if (typeof error !== "object" || error === null) return false;
  // supabase-js surfaces the Postgres SQLSTATE on PostgrestError.code; our
  // fetchAllRows wrappers copy it onto the Error they throw.
  return (error as { code?: unknown }).code === "42501";
}
